import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { QuillModule } from 'ngx-quill';

import { ExportProjectWizardModalPage } from './export-project-wizard-modal.page';
import { ExportProjectFormatComponent } from './export-project-format/export-project-format.component';
import { ExportProjectOptionsComponent } from './export-project-options/export-project-options.component';
import { ExportProjectDistributeComponent } from './export-project-distribute/export-project-distribute.component';

const routes: Routes = [
  {
    path: '',
    component: ExportProjectWizardModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    QuillModule.forRoot()
  ],
  declarations: [
    ExportProjectWizardModalPage,
    ExportProjectFormatComponent,
    ExportProjectOptionsComponent,
    ExportProjectDistributeComponent
  ]
})
export class ExportProjectWizardModalPageModule {}
